import fetch from '@/utils/fetch'

/**
 *获取数据词典
 * @export
 * @param {*} data
 * @returns
 */
export function getDataDict(data) {
    return fetch.request({
        url: '/sys/dataDict',
        method: 'post',
        data
    })
}

/**
 *获取某模块数据词典
 type == 1：项目 ;2：城市；3：板块;4:竞品；5:越规
 * @export
 * @param {*} data
 * @returns
 */
export function getModuleDict(data) {
    return fetch.request({
        url: '/sys/datadict/module/' + data.type,
        method: 'post',
        data
    })
}
